module.exports = __webpack_public_path__ + "static/media/fighter-jet.fd1c56a9.svg";